
  import { ComputedRef, computed, defineComponent } from 'vue'

  import Statistics from '@/components/Statistics/index.vue'
  import NoWorkouts from '@/components/Workouts/NoWorkouts.vue'
  import { AUTH_USER_STORE, SPORTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  export default defineComponent({
    name: 'StatisticsView',
    components: {
      NoWorkouts,
      Statistics,
    },
    setup() {
      const store = useStore()
      const authUser: ComputedRef<IUserProfile> = computed(
        () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
      )
      const sports: ComputedRef<ISport[]> = computed(() =>
        store.getters[SPORTS_STORE.GETTERS.SPORTS].filter((sport) =>
          authUser.value.sports_list.includes(sport.id)
        )
      )
      return { authUser, sports }
    },
  })
